import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { createAnnouncement } from "../../slices/apps/announcementSlice";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// diğer importlar
import { useDropzone } from "react-dropzone";

const AnnouncementAddModal = ({ modal, setModal }) => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);

  const { createAnnouncementLoading } = useSelector((state) => {
    return {
      createAnnouncementLoading: state.announcement.createAnnouncementLoading,
    };
  }, shallowEqual);

  useEffect(() => {
    setModal(modal);

    if (modal) {
      validation.resetForm();
      setPreview(null);
    }
  }, [modal]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      announcementTitle: "",
      announcementContent: "",
      isDefault: false,
      announcementImage: null,
    },

    validationSchema: Yup.object({
      announcementTitle: Yup.string().required("Başlık zorunludur"),
      announcementContent: Yup.string().required("İçerik zorunludur"),
      // announcementImage: Yup.mixed().required("Görsel zorunludur"),
    }),

    onSubmit: async (values) => {
      const resultAction = await dispatch(createAnnouncement(values));

      if (resultAction.meta.requestStatus === "fulfilled") {
        setModal(false);
      }
    },
  });

  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      validation.setFieldValue("announcementImage", file);

      const previewUrl = URL.createObjectURL(file);
      setPreview(previewUrl);
    },
  });

  return (
    <Modal
      size="lg"
      centered={true}
      isOpen={modal}
      toggle={() => {
        setModal(false);
      }}
    >
      <ModalHeader
        className="modal-title "
        id="myLargeModalLabel"
        toggle={() => {
          setModal(false);
        }}
      >
        Yeni Duyuru Ekle
      </ModalHeader>

      <ModalBody>
        <Form action="#" autoComplete="off">
          <Row className="align-items-start gy-3">
            <Col lg={12}>
              <Label htmlFor="announcementTitle" className="form-label">
                Başlık
              </Label>
              <Input
                name="announcementTitle"
                className="form-control"
                placeholder="Başlık"
                type="text"
                autoComplete="off"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.announcementTitle || ""}
                invalid={
                  validation.touched.announcementTitle &&
                  validation.errors.announcementTitle
                    ? true
                    : false
                }
              />
              {validation.touched.announcementTitle &&
                validation.errors.announcementTitle && (
                  <FormFeedback type="invalid">
                    {validation.errors.announcementTitle}
                  </FormFeedback>
                )}
            </Col>

            <Col lg={12}>
              <Label htmlFor="announcementContent" className="form-label">
                İçerik
              </Label>
              <Input
                name="announcementContent"
                className="form-control"
                placeholder="Duyuru içeriğini giriniz"
                type="textarea"
                autoComplete="off"
                rows="5"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.announcementContent || ""}
                invalid={
                  validation.touched.announcementContent &&
                  validation.errors.announcementContent
                    ? true
                    : false
                }
                style={{ resize: "none" }}
              />
              {validation.touched.announcementContent &&
                validation.errors.announcementContent && (
                  <FormFeedback type="invalid">
                    {validation.errors.announcementContent}
                  </FormFeedback>
                )}
            </Col>

            <Col xs={12}>
              <div
                {...getRootProps()}
                style={{
                  border: "1px dashed #aaa",
                  padding: "30px",
                  borderRadius: "8px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
                className="mb-3 mt-3"
              >
                <input {...getInputProps()} />
                <p className="mb-0">Görseli buraya bırak veya tıkla</p>
                {preview && (
                  <div className="mt-2" style={{ display: "inline-block" }}>
                    <img
                      src={preview}
                      alt="preview"
                      className="img-fluid rounded"
                      style={{
                        maxHeight: "300px",
                      }}
                    />
                  </div>
                )}
                {validation.touched.announcementImage &&
                  validation.errors.announcementImage && (
                    <div className="text-danger mt-2">
                      {validation.errors.announcementImage}
                    </div>
                  )}
              </div>
              {preview && (
                <div className="mt-2 text-start">
                  <Button
                    color="danger"
                    size="sm"
                    type="button"
                    onClick={() => {
                      setPreview(null);
                      validation.setFieldValue("announcementImage", null);
                    }}
                  >
                    <i className="bx bx-trash me-1"></i>
                    Görseli Kaldır
                  </Button>
                </div>
              )}
            </Col>
          </Row>

          <div className="d-flex align-items-center gap-3 mt-4">
            <Button
              type="button"
              onClick={() => {
                validation.handleSubmit();
              }}
              className="btn btn-sm ms-auto nexttab nexttab"
              color="primary"
              disabled={createAnnouncementLoading}
            >
              Kaydet
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AnnouncementAddModal;
